import {
    BroadcastResponse,
    Input,
    Output,
    SERVER_URL,
    SESSION_HEARTBEAT_URL,
    SESSION_SPEECH_TOKEN_URL,
    SESSION_URL
} from '../contexts/Configuration';
import {SessionStartedResponse, SpeechTokenRefreshResponse} from '../reducers/sessionReducer';

export class RosettaClient {

    public static async startSession(input: Input, outputs: Output[], sessionDuration: number, broadcastEnabled: boolean, token: string) {

        const body = {
            input: input,
            outputs: outputs.map(o => ({
                ...o,
                language: {...o.language, voiceName: o.language.voices[o.voiceIndex]?.name}
            })),
            sessionTimeout: sessionDuration * 60 * 1000, //sent to back in milliseconds
            broadcastEnabled: broadcastEnabled
        };

        return await fetch(`${SERVER_URL}${SESSION_URL}`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(body)

        })
            .then(response => RosettaClient.marshalSessionResponse(response as SessionStartedResponse))
            .then(response => {
                console.log('SessionStarted response -> ', response);
                return response;
            });
    }

    public static async refreshAzureSpeechToken(authToken: string) {
        const body = {
            type: 'refresh-speech-token'
        }
        return await fetch(`${SERVER_URL}${SESSION_SPEECH_TOKEN_URL}`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                Authorization: `Bearer ${authToken}`
            },
            body: JSON.stringify(body)

        })
            .then(response => RosettaClient.marshalSpeechTokenRefreshResponse(response as SpeechTokenRefreshResponse))
            .then(response => {
                //console.log('refreshAzureSpeechToken response -> ', response);
                return response;
            });
    }

    public static async sendHeartbeat(token: string, sessionId: string) {
        console.log('-------------> sendHeartbeat [dentro]')
        const body = {sessionId: sessionId};
        return await fetch(`${SERVER_URL}${SESSION_HEARTBEAT_URL}`, {
            method: 'POST',
            headers: {'content-type': 'application/json', Authorization: `Bearer ${token}`},
            body: JSON.stringify(body)
        })
    }

    private static marshalSessionResponse = async (response: SessionStartedResponse) => {
        const responseJson = await response.json();
        if (!!responseJson.errors) {
            if ('NOT_ENOUGH_CREDITS' === responseJson.errors) {
                throw new Error(`Unable to start session: your current balance is not enough to start a new session.\nAdd more credits or contact support if you believe this is wrong.`)
            } else if ('AVAILABLE_CREDITS_NOT_ENOUGH_FOR_TIMEOUT' === responseJson.errors) {
                throw new Error(`Unable to start session: you configured a session duration greater than the available balance.\nAdd more credits or contact support if you believe this is wrong.`)
            }

            throw new Error(`Unable to start session: ${responseJson.errors}`)
        }
        return responseJson;
    }

    private static marshalSpeechTokenRefreshResponse = async (response: SpeechTokenRefreshResponse) => {
        if (response.status === 200) {
            const responseJson = await response.json();
            if (!!responseJson.errors) {
                throw new Error(`Unable to start session: ${responseJson.errors}`)
            }
            return responseJson;
        }
        // if (response.status === 400) return response.json().then(r => throw new Error(r.message));
        throw new Error(`Session failed to start (error status ${response.status} - ${response.type}): ${response.statusText}`)
    }

    public static marshalBroadcastResponse = async (response: BroadcastResponse) => {
        if (response.status === 200) {
            return await response.json();
        }
        // if (response.status === 400) return response.json().then(r => throw new Error(r.message));
        throw new Error(`Unable to retrieve translations (error status ${response.status} - ${response.type}): ${response.statusText}`)
    }
}
